import { formatCardNumber } from '~/shared/lib/formatters/formatCardNumber';
import { formatPhoneNumber } from '~/shared/lib/formatters/formatPhoneNumber';
import { type Currency } from '../../../currency';
import { orderPriorities, paymentMethods, publicStatuses, splitParts } from '../constants';
import {
    Bank,
    type Priority,
    type PaymentMethod,
    type PaymentType,
    type PublicStatus,
    Status,
    type SplitPart as SplitPartType,
    type Status as StatusType,
} from '../model';

export const formatOrder = {
    date: (dateString?: string) => {
        if (!dateString) {
            return '';
        }

        return new Date(dateString).toLocaleString();
    },
    bank: (bank?: Bank) => {
        if (!bank) {
            return '';
        }

        if (typeof bank !== 'string') {
            return 'BIN банка не определен';
        }

        if (bank === Bank.BANK_UNSPECIFIED) {
            return 'Не указан';
        }

        return bank.replace('BANK_', '').replaceAll('_', ' ');
    },
    banks: (banks?: Bank[]) => {
        if (!banks) {
            return '';
        }

        if (banks.length === 1 && banks[0] === Bank.BANK_UNSPECIFIED) {
            return 'Не указаны';
        }

        const specifiedBanks = banks.filter((bank) => {
            return bank !== Bank.BANK_UNSPECIFIED;
        });

        return specifiedBanks
            ?.map((bank) => {
                return formatOrder.bank(bank);
            })
            .join(', ');
    },
    method: (method?: PaymentMethod) => {
        if (!method) {
            return '';
        }

        const { label } =
            paymentMethods.find((p) => {
                return p.value === method;
            }) ?? {};

        return label;
    },
    priority: (priority?: Priority) => {
        if (!priority) {
            return '';
        }

        const { label } =
            orderPriorities.find((p) => {
                return p.value === priority;
            }) ?? {};

        return label;
    },
    publicStatus: (status: PublicStatus) => {
        const { label } =
            publicStatuses.find((p) => {
                return p.value === status;
            }) ?? {};

        return label;
    },
    status: (status?: StatusType) => {
        if (!status) {
            return '';
        }

        if (status === Status.STATUS_SPLIT) {
            return 'Разделен';
        }

        return '';
    },
    splitPart: (splitPart?: SplitPartType) => {
        const { label } =
            splitParts.find((p) => {
                return p.value === splitPart;
            }) ?? {};

        return label;
    },
    currency: (currency?: Currency) => {
        if (!currency) {
            return '';
        }

        return currency.replace('CURRENCY_', '');
    },
    cardNumber: formatCardNumber,
    phoneNumber: formatPhoneNumber,
    type: (type: PaymentType) => {
        return type.replace('TYPE_', '').replaceAll('_', ' ');
    },
} as const;
